import { QueryClient } from '@tanstack/react-query';

const STALE_TIME_MS = 60_000;

/** 앱 전역 QueryClient. 목록 화면이 많아 기본 재요청은 보수적으로 잡는다. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME_MS,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}
